// Banner types master file
// Fetches from /api/banner-types at app start

let bannerTypesCache = null;
let bannerTypesPromise = null;

export const fetchBannerTypes = async () => {
  if (bannerTypesCache) {
    return bannerTypesCache;
  }

  if (bannerTypesPromise) {
    return bannerTypesPromise;
  }

  bannerTypesPromise = (async () => {
    try {
      const api = (await import('./api-instance')).default;
      const response = await api.get('/banner-types');
      const data = response?.data;
      bannerTypesCache = Array.isArray(data) ? data : getFallbackBannerTypes();
      return bannerTypesCache;
    } catch (error) {
      console.error('Failed to fetch banner types:', error);
      bannerTypesCache = getFallbackBannerTypes();
      return bannerTypesCache;
    } finally {
      bannerTypesPromise = null;
    }
  })();

  return bannerTypesPromise;
};

export const getBannerTypes = () => {
  return bannerTypesCache || getFallbackBannerTypes();
};

export const getActiveBannerTypes = () => {
  const types = getBannerTypes();
  return types.filter(type => type.active && !type.legacy);
};

export const getBannerTypeByType = (type) => {
  const types = getBannerTypes();
  return types.find(t => t.type === type);
};

// Fallback banner types (matches the hardcoded ones in AddBanner.jsx)
const getFallbackBannerTypes = () => {
  return [
    {
      id: 1,
      name: 'SideBanner1',
      type: 'sidebanner1',
      displayName: 'Side Banner 1',
      active: true,
      legacy: false,
      description: 'Single image side banner',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: 2,
      name: 'SideBanner2',
      type: 'sidebanner2',
      displayName: 'Side Banner 2',
      active: true,
      legacy: false,
      description: 'Multiple image side banner',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: 3,
      name: 'ScrollerFixedBanner',
      type: 'scrollerfixedbanner',
      displayName: 'Scroller Fixed Banner',
      active: true,
      legacy: false,
      description: 'Fixed scroller banner',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: 4,
      name: 'CubeBanner',
      type: 'cubebanner',
      displayName: 'Cube Banner',
      active: true,
      legacy: false,
      description: 'Four image cube banner',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: 5,
      name: 'HeaderBanner',
      type: 'headerbanner',
      displayName: 'Header Banner',
      active: true,
      legacy: false,
      description: 'Header banner with 2 images',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: 6,
      name: 'FooterSticky',
      type: 'footer_sticky',
      displayName: 'Footer Sticky',
      active: true,
      legacy: false,
      description: 'Sticky footer banner',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: 7,
      name: 'Tower2',
      type: 'tower2',
      displayName: 'Tower 2',
      active: true,
      legacy: false,
      description: 'Tower banner with multiple images',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: 8,
      name: 'Interstitial',
      type: 'interstitial',
      displayName: 'Interstitial',
      active: true,
      legacy: false,
      description: 'Interstitial banner',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: 9,
      name: 'BrandPromoBanner',
      type: 'brand_promo_banner',
      displayName: 'Brand Promo Banner',
      active: true,
      legacy: false,
      description: 'Brand promotion banner',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};
